export default {"src":"/_next/static/image/public/images/flags/flag_352.acc467b47926707bb8cb5671e61d5df9.svg","height":16,"width":24};